import Router from 'next/router';

export const getQueryParams = () => Router.router.query;

const parseQueryParameter = (param: string) => {
    if (param === 'true') return true;
    if (param === 'false') return false;

    return param;
};

export const parseQuery = (query) => {
    const parsedQuery = Object.keys(query).reduce((result, key) => {
        const parsedValue = parseQueryParameter(query[key]);

        return { ...result, [key]: parsedValue };
    }, {});

    return parsedQuery;
};
